/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions(value) {
    if (!('SiteKey' in value) || value['SiteKey'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'SiteKey': json['SiteKey'],
    };
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsToJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'SiteKey': value['SiteKey'],
    };
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions.js.map